const env = process.env.REACT_APP_ENV || 'test';

const config_demo = {
  graphqlHttpUrl: 'https://gql-test.hopdrive.io/v1/graphql',
  graphqlWsUrl: 'wss://gql-test.hopdrive.io/v1/graphql',
  graphqlClientName: 'hopdrive-client',
  loggingEnableColoring: false,
  loggingEnabled: false,
  hopdriveAdminUrl: 'https://admin-test.hopdrive.io/',
};

const config_test = {
  graphqlHttpUrl: 'https://gql-test.hopdrive.io/v1/graphql',
  graphqlWsUrl: 'wss://gql-test.hopdrive.io/v1/graphql',
  graphqlClientName: 'hopdrive-client',
  loggingEnableColoring: false,
  loggingEnabled: false,
  hopdriveAdminUrl: 'https://admin-test.hopdrive.io/',
};

const config_prod = {
  graphqlHttpUrl: 'https://gql.hopdrive.io/v1/graphql',
  graphqlWsUrl: 'wss://gql.hopdrive.io/v1/graphql',
  graphqlClientName: 'hopdrive-client',
  loggingEnableColoring: false,
  loggingEnabled: false,
  hopdriveAdminUrl: 'https://admin.hopdrive.io/',
};

const config = {
  appEnv: env,
  name: process.env.PKG_NAME || 'hopdrive-admin',
  version: process.env.PKG_VERSION || '3.0.0',
  fullName: `${process.env.PKG_NAME}-v${process.env.PKG_VERSION}`,
  versionCheckFrequency: 3600000,

  // Firebase claims
  firebaseClaimsNamespace: 'https://hasura.io/jwt/claims',
  firebaseClaimsAllowedRegions: 'x-hasura-allowed-regions',
  firebaseClaimsAllowedRoles: 'x-hasura-allowed-roles',
  firebaseClaimsDefaultRole: 'x-hasura-default-role',
  firebaseClaimsAllowedCustomers: 'x-hasura-allowed-customers',
  firebaseClaimsAllowedPayers: 'x-hasura-allowed-payers',
  firebaseClaimsPayerChildCustomers: 'x-hasura-payer-child-customers',
  firebaseClaimsCustomerId: 'x-hasura-customer-id',
  firebaseClaimsUserId: 'x-hasura-user-id',
  firebaseClaimsDriverId: 'x-hasura-driver-id',
  firebaseClaimsUserEmail: 'x-hasura-user-email',

  // Google config
  googleClientUrl: 'https://clients3.google.com/generate_204',

  // Email config
  emailInfo: 'info@hopdrive.com',
  emailSupport: 'support@hopdrive.com',

  // Environment specific keys
  ...config_test, //opinionated default to test
  ...(env === 'demo' ? config_demo : null),
  ...(env === 'test' ? config_test : null),
  ...(env === 'production' ? config_prod : null),
};

module.exports = config;
